import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';
import { findIndex as _findIndex, find as _find } from 'lodash';
import langs from 'langs';

import { docTemplateOptionFromEntity } from 'components/forms/autocomplete/DocTemplate';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormAutocomplete from 'components/forms/FormAutocomplete';

class WhiteLabelSalesDocuments extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      editLanguage: null,
      editType: null,
    };
  }

  showSelectTemplate = (e, editLanguage, editType) => {
    e.preventDefault();

    this.setState({ editLanguage, editType });
  };

  doSelectTemplate = (type, data) => {
    const { entity } = this.props;
    const { editLanguage: language } = this.state;

    let entityKeyName = '';
    let valueList = null;
    switch (type) {
      case 'quote': {
        entityKeyName = 'defaultQuoteTemplateSettings';
        valueList = entity.getDefaultQuoteTemplateSettings().slice();
        break;
      }

      case 'invoice': {
        entityKeyName = 'defaultInvoiceTemplateSettings';
        valueList = entity.getDefaultInvoiceTemplateSettings().slice();
        break;
      }

      case 'credit_note': {
        entityKeyName = 'defaultCreditNoteTemplateSettings';
        valueList = entity.getDefaultCreditNoteTemplateSettings().slice();
        break;
      }
    }

    const index = _findIndex(valueList, ['language', language]);
    const templateSettings = data ? { language, doc_template: { ...data } } : null;
    if (data === null) {
      // remove the value from array
      valueList.splice(index, 1);
    } else if (index > -1) {
      // edit the value in array
      valueList.splice(index, 1, templateSettings);
    } else {
      // add to the entity
      valueList.push(templateSettings);
    }

    this.updateEntity(entityKeyName, valueList, [], () => this.setState({ editLanguage: null, editType: null }));
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      disabled,
      inModal,
    } = this.props;
    const { editLanguage, editType } = this.state;

    const types = ['quote', 'invoice', 'credit_note'];
    const textClassName = 'p-t-10 p-b-15 no-margin lh-13';

    return (
      <div className="clearfix">
        {entityLoaded ? (
          <div>
            <Row>
              {types.map(type => {
                return (
                  <Col xs={12} md={inModal ? 12 : 6} key={type}>
                    <div className="panel panel-transparent">
                      <div className="panel-body">
                        <p className="form-group-title">{messages.salesDoc[type + 's']}</p>
                        <div className="form-group-attached">
                          {entity.getLanguages().map(language => {
                            let settings = null;
                            switch (type) {
                              case 'quote': {
                                settings = entity.getDefaultQuoteTemplateSettings();
                                break;
                              }

                              case 'invoice': {
                                settings = entity.getDefaultInvoiceTemplateSettings();
                                break;
                              }

                              case 'credit_note': {
                                settings = entity.getDefaultCreditNoteTemplateSettings();
                                break;
                              }
                            }

                            const hasCustomTemplate = _findIndex(settings, ['language', language]) > -1;
                            const customTemplate = hasCustomTemplate && _find(settings, ['language', language]);
                            const showTemplateSelect = editLanguage === language && editType === type;

                            return (
                              <Row className="clearfix" key={language}>
                                <Col xs={5}>
                                  <div className="form-group form-group-default">
                                    <label>{messages.language}</label>
                                    <div className={textClassName}>{langs.where('1', language).local}</div>
                                  </div>
                                </Col>
                                <Col xs={7}>
                                  {showTemplateSelect ? (
                                    <FormAutocomplete
                                      label={messages.document_template}
                                      name={type}
                                      value={
                                        hasCustomTemplate
                                          ? docTemplateOptionFromEntity(customTemplate.getDocTemplate())
                                          : null
                                      }
                                      onChange={this.doSelectTemplate}
                                      returnValueObject
                                      autocompleteType="docTemplate"
                                      disabled={disabled}
                                      urlFilters={{ filters: { language, systemType: type } }}
                                      clearable
                                    />
                                  ) : (
                                    <div className="form-group form-group-default">
                                      <label>{messages.template}</label>
                                      <div className={textClassName}>
                                        {hasCustomTemplate
                                          ? customTemplate.getDocTemplate().getName()
                                          : messages.default}

                                        <a
                                          href="#chooseTemplate"
                                          className="m-l-10"
                                          onClick={e => this.showSelectTemplate(e, language, type)}
                                        >
                                          {messages.choose_template}
                                        </a>
                                      </div>
                                    </div>
                                  )}
                                </Col>
                              </Row>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </Col>
                );
              })}
            </Row>
          </div>
        ) : null}
      </div>
    );
  }
}
WhiteLabelSalesDocuments.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(WhiteLabelSalesDocuments));
